export default __webpack_public_path__ + "static/media/download.56bcfd0a.svg";